import { ConnectionStateService } from '../core/connection-state.service';
import { Component, Input, inject } from '@angular/core';
import { keysToTranslate } from 'src/app/core/util/keys-to-translate';
import { Role } from '../core/api/model/role';
import { NgClass } from '@angular/common';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  imports: [NgClass, NgbPopover, TranslateDirective, RouterLink, TranslatePipe],
})
export class NavigationComponent {
  protected connectionStateService = inject(ConnectionStateService);

  @Input()
  public currentPage!: string;

  @Input()
  public inspectionKey!: string;

  public constructor() {
    keysToTranslate([
      'LoginRequiredForSearch',
      'SelectOneInspectionForEditResults',
      'SelectOneInspectionForEditProtocol',
    ]);
  }

  public get userIsAdmin() {
    return (
      this.connectionStateService.user &&
      this.connectionStateService.user.roles &&
      this.connectionStateService.user.roles.some((r) => r === Role.AcontrolAdminK)
    );
  }
}
